import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import withStyles from '../../core/withStyles';
import styles from './MenuHeader.styles';
export const MenuHeader = ({ shadow = false, maxWidth, classes, children, }) => {
    return (_jsx("div", Object.assign({ className: cn(classes.root, shadow && classes.shadow) }, { children: _jsx("div", Object.assign({ className: classes.inner, style: { maxWidth } }, { children: children })) })));
};
export default withStyles(styles)(MenuHeader);
//# sourceMappingURL=MenuHeader.js.map